import styled from 'styled-components';

const topMarginHeight = '100px';
const topMarginWithoutNavbar = '60px';
const menuHeight = '60px';
const menuBtnSize = '50px';
const menuBtnSizeReduced = '45px';
const menuBtnsSize = '40px';

export const PreferitsContainer = styled.div`
  background: transparent;
  display: block;
  position: absolute;
  z-index: 2;
  align-items: center;
  bottom: ${(props) => props.alturaBtnFav}px;
  right: 0;
  padding: 10px;

  @media screen and (max-width: 768px) {
    margin-top: ${({ displayNav }) => (displayNav ? topMarginHeight : topMarginWithoutNavbar)};
    bottom: ${(props) => props.alturaBtnFav + 10}px;
  }
`;

export const PreferitsMenuIconWrapper = styled.div`
  display: flex;
  text-align: center;
  margin: auto;
  height: 60px;
  width: 100%;
`;
export const PreferitsIconNumber = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  font-size: 12px;
  background: #c00000;
  color: #ffffff;
  display: flex;
  z-index: 3;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`;

export const PreferitsMenuIconBtn = styled.button`
  display: flex;
  border-radius: 50%;
  height: ${menuBtnSizeReduced};
  justify-content: center;
  align-items: center;
  border: 0;
  margin: auto;
  width: ${menuBtnSizeReduced};
  z-index: 2;
  background-color: ${({ open }) => (open ? '#febf00' : '#666666')};

  @media screen and (max-width: 768px) {
    height: ${menuBtnSize};
    width: ${menuBtnSize};
  }
`;
export const PreferitsListWrapper = styled.div`
  position: absolute;
  width: 350px;
  background-color: rgba(51, 51, 51, 0.85);
  right: 12px;
  bottom: 20px;
  border-radius: 5px;
  max-height: ${({ altura }) => `calc(100vh - 140px - ${altura}px)`};

  padding: 10px;
  padding-bottom: 45px;
  border-bottom-right-radius: 25px;
  @media screen and (max-width: 768px) {
    max-height: ${({ altura }) => `calc(100vh - 180px - ${altura}px)`};
  }
  @media screen and (max-width: 465px) {
    width: 95vw;
  }
`;
export const PreferitsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;
  max-height: ${({ altura }) => `calc(100vh - 220px - ${altura}px)`};

  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #333333;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }
  @media screen and (max-width: 768px) {
    max-height: ${({ altura }) => `calc(100vh - 260px - ${altura}px)`};
  }
`;

export const PreferitsFooterButton = styled.button`
  background: transparent;
  position: absolute;
  border: none;
  padding: 0;
`;
